// Card face text is an instruction to the holder ("Get 10% from any player"),
// which reads badly anywhere the card has to be named rather than shown — spliced
// into a log sentence ("played Get 10% from any player on Bob") or used as a
// panel heading. These are the short titles used instead.
//
// Shared rather than per-screen on purpose: a card the log calls "House Tax" has
// to be called "House Tax" in the modal that plays it, or the two screens look
// like they're talking about different cards.
export const actionCardTitles: Record<ActionCardId, string> = {
  "say-no": "Say No",
  "no-effect": "No Effect",
  "advance-to-go": "Advance to Start",
  "dobule-rent": "Double Rent",
  "perform-tax-audit": "Forced 20% Tax",
  "get-interest": "20% Interest",
  "forced-auction": "Forced Auction",
  "forced-buy": "Direct Buy",
  "safe-round": "Rent Shield",
  "force-downgrade-property": "Demolish House",
  "get-200-from-player": "Take 100M",
  "get-10-percent-from-player": "Take 10% ",
  "purchase-any-property-for-double-price": "Double-Price Purchase",
  "apply-property-tax": "Property Tax",
  "get-two-more-cards": "Draw Two Cards",
  "sell-back-property-at-high-price": "Double-Price Sellback",
  "use-stock-exchange": "Stock Exchange",
  "get-10-percent-from-all-players": "Take 10% from All",
  "swap-position-with-player": "Position Swap",
  "apply-house-tax": "House Tax",
  "rent-increase-of-property": "Rent Increase",
  "change-role-for-three-turns": "Role Change",
}
